import { render, staticRenderFns } from "./enteral-product-list.vue?vue&type=template&id=2ea06e9a&scoped=true&lang=pug&"
import script from "./enteral-product-list.vue?vue&type=script&lang=ts&"
export * from "./enteral-product-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea06e9a",
  null
  
)

export default component.exports